import { FC, useCallback } from 'react';
import DatesField from 'src/common/components/DatesField';
import { formatDate } from 'src/common/utils/dateHelpers';
import useBookingMotivatorsContext from 'src/common/providers/useBookingMotivators';
import { useFormState } from 'react-final-form';
import { TripCartFormState } from 'src/listing/types';
import { useTranslation } from 'next-i18next';
import { TRIP_CART_PANEL_CALENDAR } from 'src/listing/constants';
import { useTripCartContext } from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import TripCartAttention from 'src/trip-cart-deprecated/components/TripCartAttention';
import TripCartDuration from 'src/trip-cart-deprecated/components/TripCartDuration';
import { useTripCartOptionsContext } from 'src/trip-cart-deprecated/hooks/useTripCartOptionsContext';
import classNames from 'classnames';
import DurationItem from 'src/trip-cart-deprecated/components/drawer/DurationItem';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './TripCartDateInput.module.scss';

type TripCartDateInputProps = {
  inlineDuration?: boolean;
};
const TripCartDateInput: FC<TripCartDateInputProps> = ({ inlineDuration }) => {
  const [t] = useTranslation('listing-page');
  const {
    values: {
      formSelectedDates,
      isMultiDay,
    },
  } = useFormState<TripCartFormState>();
  const {
    showPanel,
  } = useTripCartContext();
  const { optionsLoading } = useTripCartOptionsContext();
  const [start, end] = formSelectedDates;

  const showCalendar = useCallback(() => {
    // Prevent changing date during processing
    if (optionsLoading) {
      return;
    }
    showPanel(TRIP_CART_PANEL_CALENDAR);
  }, [optionsLoading, showPanel]);

  const { isDateUnavailable } = useBookingMotivatorsContext();
  const dateIsUnavailable = isDateUnavailable(formSelectedDates, isMultiDay);

  return (
    // TODO: check classes removed, is loading needed?
    <div className={styles.root}>
      <div className={getClassNames(styles, 'row', classNames({ inlineDuration }))}>
        <div className={getClassNames(styles, 'date', classNames({ loading: optionsLoading }))}>
          <DatesField
            startDate={start ? formatDate(start) : ''}
            endDate={end ? formatDate(end) : ''}
            label={t('trip-cart--date')}
            labelSize="m"
            required
            handleClick={showCalendar}
            error={dateIsUnavailable}
            withErrorMessage={false}
          >
            <TripCartAttention field="formSelectedDates" />
            {inlineDuration
            && (
              <div className={styles.durationInline}>
                <DurationItem />
              </div>
            )}
          </DatesField>
        </div>
        {!inlineDuration && (
          <div className={styles.duration}>
            <TripCartDuration showMultidayToggle={false} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TripCartDateInput;
